import React from "react";

const ClientFooter = () => {
  return (
    <>
        <footer className="pt-4 pt-lg-5 pb-3 font-size-16">
            <div className="container">
               <div className="row justify-content-between mb-lg-4 py-4 align-items-center">
                  {/* Logo + Text */}
                  <div className="col-md-7 col-lg-6 col-xl-6 col-xxl-5 mb-4 line-hight-4">
                     <div className="d-flex align-items-center">
                        <div className="me-4 footer-logo">
                           <img src="/assets/images/logo.png" className="img-fluid" />
                        </div>
                        <div className="ps-2">
                           <p className="mb-0 font-size-16 font-weight-normal line-hight-3 text-white">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-md-5 col-lg-4 col-xl-3 mb-md-4">
                     <h6 className="font-weight-semibold font-size-24 montserrat">Our Newsletter</h6>
                     <form className="d-flex mb-3 position-relative newsletter-box">
                        <input type="email" className="form-control ps-4 newsletter-input rounded-pill" placeholder="Your email address" />
                        <button className="btn newsletter-btn position-absolute rounded-pill" type="submit">
                        <i className="fa fa-paper-plane-o" aria-hidden="true"></i>
                        </button>
                     </form>
                  </div>
               </div>
               <div className="row">
                  {/* Quick Links */}
                  <div className="col-lg-8 col-xl-9">
                     <div className="row">
                        {/* Quick Links */}
                        <div className="col-md-4 col-xl-3 mb-4">
                           <h6 className="font-weight-semibold font-size-24 montserrat mb-4">Quick Links</h6>
                           <ul className="list-unstyled row row-cols-2 row-cols-md-1">
                              <li className="my-2 pt-lg-1 col"><a href="/about">About</a></li>
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_PROVIDER_SIGNUP}>Providers</a></li>
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_SIGNUP}>Parents</a></li>
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_CONTACT}>Contact</a></li>
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_PRIVACY_POLICY}>Privacy Policy</a></li>
                           </ul>
                        </div>
                        <div className="col-md-4 col-xl-3 mb-4">
                           <h6 className="font-weight-semibold font-size-24 montserrat mb-4">Trust Badges</h6>
                           <ul className="list-unstyled row row-cols-2 row-cols-md-1">
                              {/* <li className="my-2 pt-lg-1 col"><a href="#"><i className="bi bi-shield-check me-2"></i>HIPAA</a></li> */}
                              <li className="my-2 pt-lg-1 col"><span className="bi bi-shield-check me-2">HIPAA</span></li>
                              <li className="my-2 pt-lg-1 col"><span className="bi bi-shield-check me-2">SOC2</span></li>
                              {/* <li className="my-2 pt-lg-1 col"><a href="#"><i className="bi bi-shield-lock me-2"></i>SOC2</a></li> */}
                           </ul>
                        </div>
                        {/* Other Links */}
                        <div className="col-md-4 col-xl-3 mb-4">
                           <h6 className="font-weight-semibold font-size-24 montserrat mb-4">Other Links</h6>
                           <ul className="list-unstyled row row-cols-2 row-cols-md-1">
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_CONTACT}>Contact Us</a></li>
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_FAQS}>FAQs</a></li>
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_BLOGS}>Blogs</a></li>
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_CAREERS}>Career</a></li>
                              {/* <li className="my-2 pt-lg-1 col"><a href="#">Treats Glaucoma</a></li> */}
                           </ul>
                        </div>
                        {/* Information */}
                        <div className="col-md-4 col-xl-3 mb-4">
                           <h6 className="font-weight-semibold font-size-24 montserrat mb-4">Information</h6>
                           <ul className="list-unstyled row row-cols-2 row-cols-md-1">
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_PRIVACY_POLICY}>Privacy Policy</a></li>
                              {/* <li className="my-2 pt-lg-1 col"><a href="#">Shipping Policy</a></li> */}
                              <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_TERMS}>Terms & Conditions</a></li>
                              {/* <li className="my-2 pt-lg-1 col"><a href="#">Refund and Returns Policy</a></li> */}
                           </ul>
                        </div>
                     </div>
                  </div>
                  {/* Newsletter & Contact */}
                  <div className="col-lg-4 col-xl-3 mb-4">
                     <ul className="list-unstyled row row-cols-1 row-cols-md-3 row-cols-lg-1 align-items-center">
                        <li className="footer-icon col">
                           <div className="d-flex align-items-center">
                              <i className="me-3"><img src="/assets/images/footer-address.svg" className="img-fluid" /></i>
                              <div>
                                 <h6 className="font-weight-semibold font-size-18 montserrat">Address</h6>
                                 <p className="mb-0 font-size-16 font-weight-normal line-hight-3 text-white">P.O. Box 4656, Norfolk, Virginia 23513</p>
                              </div>
                           </div>
                        </li>
                        <li className="footer-icon col my-3">
                           <div className="d-flex align-items-center">
                              <i className="me-3"><img src="/assets/images/footer-call.svg" className="img-fluid" /></i>
                              <div>
                                 <h6 className="font-weight-semibold font-size-18 montserrat">Phone Number</h6>
                                 <p className="mb-0 font-size-16 font-weight-normal line-hight-3 text-white">+(757) 276-3191</p>
                              </div>
                           </div>
                        </li>
                        <li className="footer-icon col">
                           <div className="d-flex align-items-center">
                              <i className="me-3"><img src="/assets/images/footer-gmail.svg" className="img-fluid" /></i>
                              <div>
                                 <h6 className="font-weight-semibold font-size-18 montserrat">Contact Info</h6>
                                 <p className="mb-0 font-size-16 font-weight-normal line-hight-3 text-white">Info@justgen.org</p>
                              </div>
                           </div>
                        </li>
                     </ul>
                  </div>
               </div>
               {/* Bottom Footer */}
               <div className="row">
                  <div className="col-12">
                     <div className="text-center footer-bottom d-sm-flex align-items-center justify-content-center">
                        <div className="font-weight-semibold font-size-16">
                           <b className="montserrat font-weight-semibold font-size-20">Sattu baby care: </b>
                           <a href="mailto:info@JGF.in"><i className="fa fa-at me-1" aria-hidden="true"></i> Info@justgen.org</a> | 
                           <a href="tel:+9145798799">+(757) 276-3191</a>
                        </div>
                        <div className="social-icons ms-sm-2">
                           <a href="https://www.facebook.com/profile.php?id=61575600418282" target="_blank"
  rel="noopener noreferrer"><i className="fa fa-facebook"></i></a>
                           <a href="https://www.linkedin.com/company/107183458/admin/dashboard/" target="_blank"
  rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a>
                           {/* <a href="#"><i className="fa fa-instagram"></i></a>
                           <a href="#"><i className="fa fa-pinterest"></i></a>
                           <a href="#"><i className="fa fa-youtube"></i></a> */}
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <p className="mb-0 text-center">Copyright © The Just Generation Foundation</p>
                  </div>
               </div>
            </div>
         </footer>
    </>
  );
};

export default ClientFooter;
